interface FeatureItem {
  icon: string;
  title: string;
  description: string;
}

const features: FeatureItem[] = [
  {
    icon: 'ri-flashlight-line',
    title: '实时更新',
    description: '7×24小时不间断追踪，全网热点第一时间推送，吃瓜快人一步，绝不掉队。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量内容',
    description: '覆盖娱乐圈、网红圈、商业圈全领域，每日上百条新鲜爆料持续上新。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '深度挖掘',
    description: '独家爆料与幕后真相追踪，不止于表面新闻，深入事件背后的来龙去脉。',
  },
  {
    icon: 'ri-group-line',
    title: '社区互动',
    description: '百万吃瓜群众在线讨论，发表你的神评论，与志同道合的瓜友一起畅聊。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            吃瓜特色
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            为什么百万吃瓜群众选择我们？四大优势让你吃瓜无忧
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-50 flex items-center justify-center mb-4 group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-xl text-primary-500`}></i>
              </div>
              <h3 className="text-base font-medium text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}